export default {"src":"/_next/static/media/ManSitting.d91e5d48.svg","height":130,"width":362,"blurWidth":0,"blurHeight":0};